import { inject, provide, Ref } from 'vue'
import { WidgetConfig } from '@/types/dashboard'

const WidgetParameterWizardToken = Symbol('WidgetParameterWizardKey')

export interface IWidgetParameterWizardContext {
    getParameter: (parameterName: string) => WidgetConfig | undefined
    getOriginalParameter: (parameterName: string) => WidgetConfig | undefined
    scratch: Ref<Record<string, unknown>>
}

export function useWidgetParameterWizardProvide (context: IWidgetParameterWizardContext) {
    provide(WidgetParameterWizardToken, context)
}

export function useWidgetParameterWizardInject () {
    return inject<IWidgetParameterWizardContext | undefined>(WidgetParameterWizardToken, undefined)
}
